export const initHideOnScrollEffect = (
  id: string,
  viewableHeightDesktop: number,
  viewableHeightMobile: number,
) => {
  const app = document.querySelector<HTMLElement>('.app-container');
  let prevScrollpos: number | undefined = app?.scrollTop;

  const onScroll = () => {
    const currentScrollPos: number | undefined = app?.scrollTop;
    const viewPortWidth = window.innerWidth;
    const searchContainer = document.getElementById(id);

    if (
      searchContainer &&
      currentScrollPos !== undefined &&
      prevScrollpos !== undefined
    ) {
      searchContainer.style.transition = '0.3s linear';

      if (viewPortWidth < 640 && currentScrollPos > viewableHeightMobile) {
        if (prevScrollpos > currentScrollPos) {
          searchContainer.style.top = '3rem';
        } else {
          searchContainer.style.top = '-10rem';
        }
      } else if (
        viewPortWidth >= 640 &&
        currentScrollPos > viewableHeightDesktop
      ) {
        if (prevScrollpos > currentScrollPos) {
          searchContainer.style.top = '0rem';
        } else {
          searchContainer.style.top = '-10rem';
        }
      }

      if (Math.abs(prevScrollpos - currentScrollPos) > 30) {
        prevScrollpos = currentScrollPos;
      }
    }
  };

  const onResize = () => {
    const viewPortWidth = window.innerWidth;
    const searchContainer = document.getElementById(id);

    if (viewPortWidth > 640 && searchContainer && app) {
      searchContainer.style.top = '';
      searchContainer.style.position = '';
      app.style.overflow = '';
    }
  };

  if (app) {
    app.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    return () => {
      document
        .querySelector('.app-container')
        ?.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }
};
